import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  isAdmin: boolean;
  phoneNumber: string | null;
  setPhoneNumber: (phone: string | null) => void;
  setAuthenticated: (value: boolean) => void;
  setAdmin: (value: boolean) => void;
  logout: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isAdmin: false,
      phoneNumber: null,
      setPhoneNumber: (phone) => set({ phoneNumber: phone }),
      setAuthenticated: (value) => set({ isAuthenticated: value }),
      setAdmin: (value) => set({ isAdmin: value }),
      logout: () => set({ 
        isAuthenticated: false, 
        isAdmin: false, 
        phoneNumber: null 
      }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        isAdmin: state.isAdmin,
        phoneNumber: state.phoneNumber,
      }),
    }
  )
);